import {
  BookOpen,
  CalendarRange,
  HandCoins,
  Home,
  MoreHorizontal,
  Tags,
  UserCog,
  type LucideIcon,
} from 'lucide-react';

export interface NavigationItem {
  icon: LucideIcon;
  label: string;
  path: string;
  matchStartsWith?: boolean;
}

export const primaryNavigationItems: NavigationItem[] = [
  { icon: Home, label: 'Início', path: '/' },
  { icon: BookOpen, label: 'Turmas', path: '/classes', matchStartsWith: true },
  { icon: CalendarRange, label: 'Trimestres', path: '/trimestres', matchStartsWith: true },
  { icon: MoreHorizontal, label: 'Mais', path: '/mais' },
];

export const secondaryNavigationItems: NavigationItem[] = [
  { icon: Tags, label: 'Segmentos', path: '/segmentos' },
  { icon: HandCoins, label: 'Ofertas', path: '/ofertas' },
  { icon: UserCog, label: 'Perfil', path: '/perfil' },
];

export const findNavigationItemByPath = (pathname: string) => {
  const allItems = [...primaryNavigationItems, ...secondaryNavigationItems];

  return allItems.find((item) => {
    if (item.path === '/') {
      return pathname === '/';
    }

    if (item.matchStartsWith) {
      return pathname === item.path || pathname.startsWith(`${item.path}/`);
    }

    return pathname === item.path;
  });
};
